/* eslint-disable no-useless-escape */
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button } from '@mui/material';
import * as Yup from 'yup';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { CloseRounded } from '@mui/icons-material';
import { toast } from 'react-toastify';

import { Input } from '../../../../components/Input';

import {
  Content,
  InputSection,
  Section,
  SectionHeaderDrawer,
  Title,
} from './styles';

import { updatePasswordRequest } from '../../../../services';

import useAuthStore from '../../../../store/auth';

interface EditPasswordProps {
  setOpenDrawer: (type: boolean) => void;
}

export const EditPassword = ({ setOpenDrawer }: EditPasswordProps) => {
  const user = useAuthStore(state => state.user);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      currentPassword: Yup.string()
        .min(8, 'Mínimo de 8 Dígitos')
        .required('O campo senha é obrigatório')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          'A senha deve conter 1 maiúscula, 1 número e 1 caractere especial (como !, @, #, etc.)',
        ),
      newPassword: Yup.string()
        .min(8, 'Mínimo de 8 Dígitos')
        .required('O campo senha é obrigatório')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          'A senha deve conter 1 maiúscula, 1 número e 1 caractere especial (como !, @, #, etc.)',
        ),
      confirmNewPassword: Yup.string()
        .min(8, 'Mínimo 8 Dígitos')
        .oneOf([Yup.ref('newPassword'), null], 'Digite a nova senha')
        .required('As senhas não coincidem'),
    });
  }, []);

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const handleChangePassword = useCallback(
    async (formData: any) => {
      try {
        const response = await updatePasswordRequest({
          old_password: formData.currentPassword,
          email: user?.email as string,
          password: formData.newPassword,
        });

        if (response?.status === 201) {
          toast.success('Senha alterada com sucesso');
          setOpenDrawer(false);
        } else {
          toast.error('Não foi possível alterar a senha');
        }
      } catch (error) {
        console.log(error);
      }
    },
    [setOpenDrawer, user?.email],
  );

  return (
    <Box sx={{ width: '560px', height: '100%' }} role="presentation">
      <Content>
        <SectionHeaderDrawer>
          <CloseRounded
            sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
            onClick={() => setOpenDrawer(false)}
          />
          <Title>Alterar Senha</Title>
        </SectionHeaderDrawer>
        <form onSubmit={handleSubmit(handleChangePassword)}>
          <Section>
            <InputSection>
              <Input
                className="inputMember"
                id="outlined-basic"
                name="currentPassword"
                type="text"
                label="Senha atual"
                control={control}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Input
                className="inputMember"
                id="outlined-basic"
                name="newPassword"
                type="text"
                label="Nova senha"
                control={control}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Input
                className="inputMember"
                id="outlined-basic"
                name="confirmNewPassword"
                type="text"
                label="Repita nova senha"
                control={control}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </InputSection>
            <Box width="100%" display="flex" justifyContent="end">
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={isSubmitting}
                sx={{
                  width: '197px',
                  height: '42px',
                  color: '#FFFFFF',
                  fontSize: '15px',
                  fontWeight: '500',
                  whiteSpace: 'nowrap',
                }}
              >
                Alterar senha
              </Button>
            </Box>
          </Section>
        </form>
      </Content>
    </Box>
  );
};
